'use client';
import React from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import Button from '@pezeshk-book/ui-kit/button';
import process from 'process';
import routes from '@routes';
import { UsersActions } from '@store/users/users-action';
import { useDispatch } from 'react-redux';
import { PharmaciesActions } from '@store/pharmacies/pharmacies-actions';
import { useParams } from 'next/navigation';
import getParseRoute from '@utils/helpers/parse-route';
import { LocaleTypes } from '@dictionaries-types';

const OrderButtons = ({ orderTitle, consultTitle }: {orderTitle: string, consultTitle: string}) => {
  const dispatch = useDispatch();
  const { lang } = useParams<{lang: LocaleTypes}>();
  const handleSelectCityModal = () => {
    dispatch(PharmaciesActions.setCityModal({ open: true }));
    dispatch(PharmaciesActions.setCityHref({ href: routes['route.pharmacies.otc'] }));
  };

  const handleSelectConsult = () => {
    dispatch(UsersActions.setFilterItems({
      key: 'serviceType',
      value: 'مشاوره',
      id: '2',
    }));
  };

  return (
    <Div className={'flex-col items-center'}>
      <Button disabled={process.env.PHARMACY_CALL_TO_ACTIONS_SERVICE_ACTIVE !== 'true'} className={'w-4/5 sm:w-1/2 mt-10'} fontType={'bold'} onClick={handleSelectCityModal}>
        {orderTitle}
      </Button>
      <Button disabled={process.env.CONSULT_SERVICE_ACTIVE !== 'true'} onClick={handleSelectConsult} fontType={'bold'} href={getParseRoute({ pathname: routes['route.users.index'], locale: lang })} variant={'outlined'} className={'w-4/5 sm:w-1/2 mt-5'}>
        {consultTitle}
      </Button>
    </Div>
  );
};

export default OrderButtons;
